<script lang="ts">
  import { copyToClipboard } from '../utils/clipboard'
  import { inlineStyle } from '../utils/inlineStyle'

  let { name, swatchStyle, size = 'lg' }: { name: string; swatchStyle: string; size?: 'sm' | 'lg' } = $props()

  let copied = $state(false)
  let timeoutId: ReturnType<typeof setTimeout> | undefined

  async function handleClick() {
    const success = await copyToClipboard(name)
    if (!success) return

    copied = true
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      copied = false
    }, 1500)
  }
</script>

<button type="button" class="swatch-button -{size}" {@attach inlineStyle(swatchStyle)} onclick={handleClick} title={name} aria-label="{name} kopieren">
  {#if copied}
    <span class="swatch-button-copied">✓</span>
  {/if}
</button>

<style>
  .swatch-button {
    border: none;
    padding: 0;
    cursor: pointer;
    border-radius: var(--radius-2);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform var(--transition-fast);

    &:hover {
      transform: scale(1.05);
    }

    &.-lg {
      width: 64px;
      height: 64px;
    }

    &.-sm {
      width: 28px;
      height: 28px;
      border-radius: var(--radius-1);
    }
  }

  .swatch-button-copied {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: color-mix(in oklch, var(--color-black) 45%, transparent);
    color: var(--color-white);
    font-size: var(--font-size-5);
    font-weight: var(--font-weight-3);
    border-radius: inherit;
  }
</style>
